import type {NavTab} from 'UI/components/layout/NavigationBar/NavigationBar';

import {AccountCircleIcon, AutoStoriesIcon, ExploreIcon, HelpOutlineIcon, MapIcon} from 'Images/icons';

/** Navigation tabs shown to authenticated users. */
export const AUTH_TABS: NavTab[] = [
    {
        href: '/',
        icon: <ExploreIcon height={24} width={24} />,
        key: 'home',
        label: 'nav.home'
    },
    {
        href: '/map',
        icon: <MapIcon height={24} width={24} />,
        key: 'map',
        label: 'nav.map'
    },
    {
        href: '/account',
        icon: <AutoStoriesIcon height={24} width={24} />,
        key: 'library',
        label: 'nav.library'
    },
    {
        href: '/faq',
        icon: <HelpOutlineIcon height={24} width={24} />,
        key: 'faq',
        label: 'nav.faq'
    }
];

/** Navigation tabs shown to unauthenticated (guest) users. */
export const GUEST_TABS: NavTab[] = [
    {
        href: '/',
        icon: <ExploreIcon height={24} width={24} />,
        key: 'home',
        label: 'nav.home'
    },
    {
        href: '/map',
        icon: <MapIcon height={24} width={24} />,
        key: 'map',
        label: 'nav.map'
    },
    {
        href: '/faq',
        icon: <HelpOutlineIcon height={24} width={24} />,
        key: 'faq',
        label: 'nav.faq'
    },
    {
        href: '/login',
        icon: <AccountCircleIcon height={24} width={24} />,
        key: 'login',
        label: 'nav.login'
    }
];